import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { Patient } from "src/app/shared/models/patients";
import { ToastrService } from "ngx-toastr";
import { PrescriptionService } from "../../prescription.service";
import { UserAccount } from "src/app/shared/models/user-account";
import { DmsDocument } from "src/app/shared/models/dms-document";
import { Constants } from "src/app/shared/models/constants";
import { DrugService } from "src/app/shared/drug.service";
import { Drug } from "src/app/shared/models/drug";
import { noop, Observable, of } from "rxjs";
import {
  tap,
  debounceTime,
  mergeMap,
  map,
  buffer,
  filter,
  finalize,
  switchMap,
  startWith,
  distinctUntilChanged,
} from "rxjs/operators";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { AppService } from "src/app/core/service/app.service";
import { AuthService } from "src/app/core/service/auth.service";
import { DoctorService } from "src/app/doctor/doctor.service";
import { DoctorDetails } from "src/app/shared/models/doctorDetails";
import { NotificationService } from "src/app/shared/notification.service";
import { userRole } from "src/app/shared/userRole";
import { EncryptDecryptParametersServiceService } from "src/app/core/service/encrypt-decrypt-parameters-service.service";
import PharmcistService from "src/app/pharmacist/pharmcist.service";
import { MatDialog } from "@angular/material/dialog";
import { DrugServiceService } from "src/app/shared/drug/drug-service.service";
import { PrescriptionCode } from "src/app/shared/models/prescriptionCode";
import { ActivityType } from "src/app/shared/ActivityType";
import { PatientService } from "src/app/doctor/patient/patient.service";
import { ENTER, COMMA, SPACE } from "@angular/cdk/keycodes";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
declare var SignaturePad: any;
import { PaginationVM } from "src/app/shared/models/pagination-vm";
@Component({
  selector: "app-create",
  templateUrl: "./create.component.html",
  styleUrls: ["./create.component.sass"],
})
export class CreateComponent implements OnInit {
  paginationVM2: PaginationVM<DoctorDetails>;
  patientSelectionForm: FormGroup;
  createDrugForm: FormGroup;
  patientSearchForm: FormGroup;
  patient: Patient;
  IsPatient: boolean = true;
  fileObj: any = null;
  patientList: Array<Patient>;
  currentUser: UserAccount;
  myControl = new FormControl();
  constants: any;
  canvas: HTMLElement | undefined;
  drugList: Array<Drug>;
  filterList: Array<Drug>;
  lineItem: any;
  filteredOptions: Observable<Drug[]>;
  filteredPrescriptionCode$: Observable<PrescriptionCode[]>;
  drugControl = new FormControl();
  isSignatureValid: boolean = false;
  drug: Drug;
  drugs$: Observable<Drug[]>;
  formControl = new FormControl();
  isEditDrug = false;
  selectedDrugList: {
    id: number;
    name: string;
    description: String;
    refill: number;
    status: string;
  }[];
  index: number;
  @ViewChild("createDrug") private formDirective: NgForm;
  @ViewChild("sigCodeInput") sigCodeInput: ElementRef<HTMLInputElement>;
  signaturePads: any;
  currentDate = new Date();
  // filteredUsers: Observable<any>[];
  filteredUsers$: Observable<Patient[]>;
  filteredDrugs$: Observable<Drug[]>;
  isLoading: boolean;
  doctorDetails: DoctorDetails;
  prescriptionId: any;
  @ViewChild("CancelPrescriptionComponent")
  CancelPrescriptionComponent: TemplateRef<any>;
  @ViewChild("DeleteDrugComponent")
  DeleteDrugComponent: TemplateRef<any>;
  @ViewChild("EditDrugComponent")
  EditDrugComponent: TemplateRef<any>;
  drugName: any;
  drugc: any;
  prescriptionCode: PrescriptionCode;
  sighs = [];
  // separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodes: number[] = [ENTER,SPACE];
  discriptionArr=[];
  // canvas = document.getElementById("signature-pad");
  constructor(
    private formBuilder: FormBuilder,
    private patientService: PatientService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private prescriptionService: PrescriptionService,
    private drugService: DrugServiceService,
    private datePipe: DatePipe,
    private router: Router,
    private appService: AppService,
    private authService: AuthService,
    private doctorService: DoctorService,
    private notificationService: NotificationService,
    private encryptDecryptParametersService: EncryptDecryptParametersServiceService,
    private pharmacistService: PharmcistService,
    public dialog: MatDialog
  ) {
    // const _this = this;
    // _this.signaturePads = new SignaturePad(this.canvas, {
    //   backgroundCoor: 'rgb(255, 255, 255)',
    //   width: '451px',
    // });
    this.patient = new Patient();
    this.patientSelectionForm = this.formBuilder.group({
      picture: [""],
      firstName: ["", Validators.required],
      middleName: [""],
      lastName: ["", Validators.required],
      email: [""],
      phone: [""],
      address: [""],
      allergies: ["", [Validators.maxLength(250)]],
      age: [
        this.patient.Age,
        [
          Validators.required,
          Validators.maxLength(3),
          Validators.max(150),
          Validators.min(1),
        ],
      ],
      insuranceInformation: [
        this.patient.InsuranceInformation,
        // Validators.maxLength(500),
      ],
      patientIdentifier: [
        this.patient.PatientIdentifier,
        // Validators.maxLength(150),
      ],
      gender: ["", Validators.required],
    });

    this.createDrugForm = this.formBuilder.group({
      drugName: ["", Validators.required],
      description: ["", Validators.required],
      codeName: [""],
      refill: [""],
    });
    this.patientSearchForm = this.formBuilder.group({
      name: ["", Validators.required],
    });
    this.patientList = new Array<Patient>();
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
    this.constants = Constants;
    this.drugList = new Array<Drug>();
    this.selectedDrugList = [];
    this.filteredUsers$ = new Observable<Patient[]>();
    this.filteredDrugs$ = new Observable<Drug[]>();
  }

  ngOnInit(): void {
    const _this = this;
    setTimeout(function () {
      var canvas = document.getElementById("signature-pad");
      _this.signaturePads = new SignaturePad(canvas, {
        backgroundCoor: "rgb(255, 255, 255)",
        width: "451px",
      });
    }, 1000);
    // this.GetPatientList();
    this.filteredUsers$ = this.patientSearchForm.get("name").valueChanges.pipe(
      debounceTime(300),
      switchMap((value) => {
        return this.patientService
          .ListPatientForDropdown({
            firstName: value,
            lastName: value,
            doctorAccountId: this.currentUser.Id,
          })
          .pipe(
            map((data: any) => (data && data.Rows) || []),
            tap(
              () => noop,
              (err) => {}
            )
          );
      })
    );
    this.filteredDrugs$ = this.createDrugForm.get("drugName").valueChanges.pipe(
      debounceTime(300),
      switchMap((value) => {
        return this.drugService.ListDrug(value).pipe(
          map((data: any) => (data && data?.Rows) || []),
          tap(
            () => noop,
            (err) => {}
          )
        );
      })
    );

    this.filteredPrescriptionCode$ = this.createDrugForm
      .get("codeName")
      .valueChanges.pipe(
        debounceTime(300),
        switchMap((value) => {
          this.paginationVM2 = <PaginationVM<DoctorDetails>>{
            UserRoleId: this.currentUser.UserRoleId,
            PageNumber: 1,
            PageSize: 10,
            TotalCount: 0,
            UserRole: null,
            Records: new Array<DoctorDetails>(),
            SortBy: "CreatedDate",
            SortOrder: false,
            Filter: {
                Id: 0,
                Code: value,
                IsActive: "",
                CreatedById: 0,
                CreatedDate: null,
              }
          };

           return this.prescriptionService.GetPrescriptionCode(this.paginationVM2)
            .pipe(map((data: any) => (data && data.Records) || []),
              tap(() => noop,
                (err) => {}
              )
            );
        })
      );

    this.GetDoctorDetail();
    if (this.router.url.includes("?")) {
      const finalURL =
        this.router.url.split("?")[0] +
        "?" +
        this.encryptDecryptParametersService.decrypt(this.router.url);
      var data = JSON.parse(
        this.encryptDecryptParametersService.getQueryParams("details", finalURL)
      );
      this.prescriptionId = data.Id;
      this.getDrugListByPrescriptionId(this.prescriptionId);
    }
  }

  AddPatient() {
    if (this.patientSelectionForm.valid) {
      if (this.patient.Id == 0) {
        let patientFirstName = this.patientSelectionForm.get("firstName").value;
        let patientLastName = this.patientSelectionForm.get("lastName").value;
        let patientDetails = {
          firstName: patientFirstName,
          lastName: patientLastName,
          physicianAccountId: this.currentUser.Id,
        };
        this.patientService.IsPatientExistBySameName(patientDetails).subscribe({
          next: (resp: any) => {
            if (!resp.HasErrors) {
              if (!resp?.IsError) {
                this.IsPatient = false;
                this.clearSignature();
                this.GetDrugList();
              } else {
                this.authService.showNotification(
                  "snackbar-danger",
                  resp.message,
                  "top",
                  "center"
                );
              }
            } else {
              this.spinner.hide();
              this.toastr.error("something went wrong.");
            }
          },
        });
      } else {
        this.IsPatient = false;
        this.clearSignature();
        this.GetDrugList();
      }
    }
  }

  private mat_filter(value: string): Drug[] {
    const filterValue = value.toLowerCase();
    this.filterList = this.drugList.filter((option) =>
      option.Name.toLowerCase().includes(filterValue)
    );
    return this.filterList;
  }

  back() {
    this.IsPatient = true;
    this.selectedDrugList = [];
    this.resetDrugForm();
  }

  // ValidSignature() {
  //   if (this.signaturePads.toDataURL("image/png") == "") {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }

  CreatePrescription() {
    if (
      this.selectedDrugList.length != 0 &&
      this.signaturePads.toDataURL("image/png") !=
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACWCAYAAABkW7XSAAAAAXNSR0IArs4c6QAABGJJREFUeF7t1AEJAAAMAsHZv/RyPNwSyDncOQIECEQEFskpJgECBM5geQICBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAgQdWMQCX4yW9owAAAABJRU5ErkJggg=="
    ) {
      var patient = {
        Id: this.patient.Id,
        FirstName: this.patientSelectionForm.get("firstName").value,
        MiddleName: this.patientSelectionForm.get("middleName").value,
        LastName: this.patientSelectionForm.get("lastName").value,
        Address: this.patientSelectionForm.get("address").value,
        Email: this.patientSelectionForm.get("email").value,
        Phone: this.patientSelectionForm.get("phone").value,
        InsuranceInformation: this.patientSelectionForm.get(
          "insuranceInformation"
        ).value,
        PatientIdentifier: this.patientSelectionForm.get("patientIdentifier")
          .value,
        Note: this.patientSelectionForm.get("allergies").value,
        Age: this.patientSelectionForm.get("age").value,
        PhysicianAccountId: this.currentUser.Id,
        IsActive: true,
        ProfilePictureId: this.patient.ProfilePictureId,
        ProfilePictureThumbId: this.patient.ProfilePictureThumbId,
        Gender:
          this.patientSelectionForm.get("gender").value == "M" ? "M" : "F",
        CreatedDate: this.patient.CreatedDate,
        CreatedById: this.patient.CreatedById,
      };

      var prescription = {
        Id: 0,
        PatientId: 0,
        PhysicianId: this.currentUser.Id,
        Status: "",
        PrescriptionNo: "",
        IsActive: true,
        Signature: this.signaturePads.toDataURL("image/png"),
        CreatedById: this.currentUser.Id,
      };
      var prescriptionDetailsList: any[] = [];

      this.selectedDrugList.forEach((drug) => {
        var lineItem = {
          Id: 0,
          PrescriptionId: 0,
          DrugId: drug.id,
          Description: drug.description,
          Refill: drug.refill,
          Status: "",
        };
        prescriptionDetailsList.push(lineItem);
      });

      var prescriptionDetails = {
        Patient: patient,
        Prescription: prescription,
        PrescriptionDetails: prescriptionDetailsList,
        FilesProfile: this.fileObj,
        userAccount: this.currentUser,
      };

      var patientDetails = {
        prescriptionDetails: prescriptionDetails,
        FilesProfile: this.fileObj,
      };
      this.spinner.show();
      this.prescriptionService.CreatePrescription(patientDetails).subscribe({
        next: (resp: any) => {
          if (!resp.HasErrors) {
            this.notificationService.AddPrescription(resp);
            this.authService.showNotification(
              "snackbar-success",
              "Prescription created successfully.",
              "top",
              "center"
            );
            var gender = "";
            if (resp.Patient.Gender == "M") {
              gender = "Mr.";
            } else if (resp.Patient.Gender == "F") {
              gender = "Ms.";
            } else {
              gender = "";
            }
            this.AddNotification(
              resp.Prescription.PrescriptionNo,
              resp.Patient.FirstName + " " + resp.Patient.LastName,
              this.currentUser.FirstName + " " + this.currentUser.LastName,
              gender
            );
            this.AddUserActivity(resp.Prescription.PrescriptionNo);
            this.router.navigateByUrl("doctor/prescription/list");
            this.spinner.hide();
          } else {
            this.spinner.hide();
            this.authService.showNotification(
              "snackbar-danger",
              resp.Errors[0].Message,
              "top",
              "center"
            );
          }
        },
        error: () => {
          this.spinner.hide();
          this.authService.showNotification(
            "snackbar-danger",
            "Failed to create prescription",
            "top",
            "center"
          );
        },
      });
    } else {
      if (this.selectedDrugList.length == 0) {
        this.authService.showNotification(
          "snackbar-danger",
          "Please add at least 1 drug.",
          "top",
          "center"
        );
      } else if (
        this.signaturePads.toDataURL("image/png") ==
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACWCAYAAABkW7XSAAAAAXNSR0IArs4c6QAABGJJREFUeF7t1AEJAAAMAsHZv/RyPNwSyDncOQIECEQEFskpJgECBM5geQICBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAgQdWMQCX4yW9owAAAABJRU5ErkJggg=="
      ) {
        this.authService.showNotification(
          "snackbar-danger",
          "Please, enter digital signature.",
          "top",
          "center"
        );
      }
    }
  }

  GetPatientList() {
    this.spinner.show();
    var patientDetails = {
      firstName: this.myControl.value,
      lastName: this.myControl.value,
      doctorAccountId: this.currentUser.Id,
    };

    this.patientService.ListPatientForDropdown(patientDetails).subscribe({
      next: (resp: any) => {
        this.spinner.hide();
        if (!resp.HasErrors) {
          this.patientList = resp?.Rows;
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  clearSignature(): void {
    this.signaturePads.clear();
  }

  selectedDrug(option) {
    this.drug = option?.option?.value;
  }

  // selectedPrescriptionCode(option) {
  //   this.prescriptionCode = option?.option?.value;
  //   this.createDrugForm.controls.description.setValue(
  //     this.prescriptionCode.Description
  //   );
  // }
  selectedPrescriptionCode(option) {
   
    this.prescriptionCode = option?.option?.value;
    if (this.sighs.find((x) => x.Id == this.prescriptionCode.Id) == undefined) {
      if (this.sighs.length >= 1) {
      //   this.discriptionArr.push()
      //   this.createDrugForm.controls.description.value 
      //     + " | " + this.prescriptionCode.Description
        
      //   this.createDrugForm.controls.description.setValue(
      //     this.discriptionArr
      //   );
      // } else {
      //   this.createDrugForm.controls.description.setValue(
      //     this.prescriptionCode.Description
      //   );
      // }

      if(this.discriptionArr.length==0)
      {
        this.createDrugForm.controls.description.setValue(
          this.discriptionArr.push(this.createDrugForm.controls.description.value)
        ); 
        // this.createDrugForm.controls.description.value + " | " + this.prescriptionCode.Description
      }
      else
      {
        this.createDrugForm.controls.description.setValue(
          this.discriptionArr.push(this.prescriptionCode.Description)
        );
      }

      } else {
      this.createDrugForm.controls.description.setValue(
        this.discriptionArr.push(this.prescriptionCode.Description)
      );
      }
      
      this.sighs.push(this.prescriptionCode);
    }
    // this.createDrugForm.controls.codeName.setValue("");
    this.sigCodeInput.nativeElement.value = "";
  }

  selectedPatient(value) {
    this.patient = value.option.value;
    this.patientSelectionForm.controls.firstName.setValue(
      this.patient.FirstName
    );
    this.patientSelectionForm.controls.middleName.setValue(
      this.patient.MiddleName
    );
    this.patientSelectionForm.controls.lastName.setValue(this.patient.LastName);
    this.patientSelectionForm.controls.phone.setValue(this.patient.Phone);
    this.patientSelectionForm.controls.email.setValue(this.patient.Email);
    this.patientSelectionForm.controls.allergies.setValue(this.patient.Note);
    this.patientSelectionForm.controls.address.setValue(this.patient.Address);
    this.patientSelectionForm.controls.picture.setValue(
      this.patient.ProfilePictureId
    );
    this.patientSelectionForm.controls.age.setValue(this.patient.Age);
    this.patientSelectionForm.controls.insuranceInformation.setValue(
      this.patient.InsuranceInformation
    );
    this.patientSelectionForm.controls.patientIdentifier.setValue(
      this.patient.PatientIdentifier
    );
    this.patientSelectionForm.controls.gender.setValue(
      this.patient.Gender == "M" ? "M" : "F"
    );
  }

  selectedPatient2(value) {
    this.patient = value;
    this.patientSelectionForm.controls.firstName.setValue(
      this.patient.FirstName
    );
    this.patientSelectionForm.controls.middleName.setValue(
      this.patient.MiddleName
    );
    this.patientSelectionForm.controls.lastName.setValue(this.patient.LastName);
    this.patientSelectionForm.controls.phone.setValue(this.patient.Phone);
    this.patientSelectionForm.controls.email.setValue(this.patient.Email);
    this.patientSelectionForm.controls.allergies.setValue(this.patient.Note);
    this.patientSelectionForm.controls.address.setValue(this.patient.Address);
    this.patientSelectionForm.controls.picture.setValue(
      this.patient.ProfilePictureId
    );
    this.patientSelectionForm.controls.age.setValue(this.patient.Age);
    this.patientSelectionForm.controls.insuranceInformation.setValue(
      this.patient.InsuranceInformation
    );
    this.patientSelectionForm.controls.patientIdentifier.setValue(
      this.patient.PatientIdentifier
    );
    this.patientSelectionForm.controls.gender.setValue(
      this.patient.Gender == "M" ? "M" : "F"
    );
    this.displayFn(this.patient);
  }

  deleteDrugConfirm(drug) {
    this.drugc = drug;
    const dialogRef = this.dialog.open(this.DeleteDrugComponent, {
      maxWidth: "750px",
      disableClose: true,
    });
  }

  editDrugConfirm(drug) {
    this.filteredDrugs$ = new Observable<Drug[]>();
    this.drugc = drug;
    const dialogRef = this.dialog.open(this.EditDrugComponent, {
      maxWidth: "750px",
      disableClose: true,
    });
  }

  deleteDrug(drug) {
    this.index = this.selectedDrugList.indexOf(drug);
    if (this.index > -1) {
      this.selectedDrugList.splice(this.index, 1);
    }
    this.dialog.closeAll();
  }

  editDrug(drug) {
    this.drugName = drug;
    this.drug = this.drugList.find((x) => x.Id == drug.id);
    this.createDrugForm.controls.drugName.setValue(this.drug);
    this.createDrugForm.controls.description.setValue(drug.description);
    this.createDrugForm.controls.refill.setValue(drug.refill);
    this.isEditDrug = true;
    this.index = this.selectedDrugList.indexOf(drug);
    this.dialog.closeAll();
  }

  SaveDrug() {
    if (this.drug == undefined) {
      this.authService.showNotification(
        "snackbar-danger",
        "Please select valid drug from menu.",
        "top",
        "center"
      );
    }
    if (!this.isEditDrug) {
      if (this.createDrugForm.valid && this.drug != undefined) {
        var drug = {
          id: this.drug.Id,
          name: this.drug.Name,
          description: this.createDrugForm.get("description").value,
          refill: this.createDrugForm.get("refill").value,
          status: "Pending",
        };
        if (
          this.selectedDrugList.find((x) => x.id == this.drug.Id) == undefined
        ) {
          this.selectedDrugList.push(drug);
        } else if (this.selectedDrugList.find((x) => x.id == this.drug.Id)) {
          this.authService.showNotification(
            "snackbar-danger",
            "selected drug already taken.",
            "top",
            "center"
          );
        }
        this.clearDrugForm();
        this.drug = null;
      }
    } else {
      if (this.createDrugForm.valid && this.drug != undefined) {
        var drug = {
          id: this.drug.Id,
          name: this.drug.Name,
          description: this.createDrugForm.get("description").value,
          refill: this.createDrugForm.get("refill").value,
          status: "Pending",
        };
        this.selectedDrugList[this.index] = drug;
        this.isEditDrug = false;
        this.clearDrugForm();
        this.drug = null;
      }
    }
  }

  clearDrugForm() {
    this.createDrugForm.reset({
      description: "",
      drugName: "",
    });
    this.createDrugForm.clearValidators();
    this.formDirective.resetForm();
    this.drug = null;
    this.GetFavoriteDrugs();
  }

  resetDrugForm() {
    this.drug = null;
    this.createDrugForm.reset();
    this.createDrugForm.get("drugName").reset();
    this.createDrugForm.get("description").reset();
  }

  filter(values) {
    return values.filter((joke) => joke.joke.toLowerCase().includes(this.drug));
  }

  GetDrugList() {
    var drugDetails = {
      name: null,
    };
    this.drugService.ListDrug(drugDetails.name).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.drugList = resp?.Rows;
          this.filterList = this.drugList;
        }
      },
      error: () => {},
    });
  }
  onKey(value) {
    this.filterList = this.search(value);
  }
  search(value: string) {
    let filter = value.toLowerCase();
    return this.drugList.filter((option) =>
      option.Name.toLowerCase().startsWith(filter)
    );
  }

  displayFn(patient: Patient) {
    if (patient) {
      return patient.FirstName + " " + patient.LastName;
    }
  }

  displayFn2(drug: Drug) {
    if (drug) {
      return drug.Name;
    }
  }

  displayFn3(code: PrescriptionCode) {
    if (code) {
      return code.Code;
    }
  }

  SaveDrugs() {
    if (this.createDrugForm.valid) {
    }
  }

  uploadProfile(evt) {
    if (evt.target.files.length !== 0) {
      const files = evt.target.files;
      const file = files[0];
      const reader = new FileReader();
      if (files && file) {
        reader.onload = this._handleReaderLoadeds2.bind(this, file);
        reader.readAsArrayBuffer(file);
      }
    }
  }

  _handleReaderLoadeds2(file, readerEvt) {
    this.spinner.show();
    if (
      file.type === "image/png" ||
      file.type === "image/jpeg" ||
      file.type === "image/jpg"
    ) {
      if (file.size < 5051341) {
        const buffer = readerEvt.target.result;
        const base64file = this.arrayBufferToBase64(buffer);
        const fileObj = {
          FileName: file.name,
          File: base64file,
          DocumentType: file.type,
          status: "1",
        };
        this.fileObj = fileObj;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.authService.showNotification(
          "snackbar-danger",
          "File size exceeds 5Mb",
          "top",
          "center"
        );
        this.patientSelectionForm.controls.picture.setValue(null);
      }
    } else {
      this.spinner.hide();
      this.authService.showNotification(
        "snackbar-danger",
        "The filetype you are attempting to upload is not allowed.",
        "top",
        "center"
      );
      this.patientSelectionForm.controls.picture.setValue(null);
    }
  }

  arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  previous() {
    this.IsPatient = true;
  }

  onSubmit() {}

  GetDoctorDetail() {
    var doctorDetails = {
      doctorAccountId: this.currentUser.Id,
    };
    this.spinner.show();
    this.doctorService.GetDoctorDetailsById(doctorDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.doctorDetails = resp;
          this.GetFavoriteDrugs();
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  AddNotification(prescriptionNo, patientName, doctorName, gender) {
    var notification = {
      Title: "You have new prescription.",
      Description: `You have new prescription from Dr.${doctorName} for ${gender}  ${patientName}`,
      ReceiverAccountId: null,
      ReceiverRoleId: userRole.pharmacist,
      SenderAccountId: this.currentUser.Id,
      CreatedById: this.currentUser.Id,
      IsRead: false,
    };
    var notificationDetails = {
      Notification: notification,
    };
    this.spinner.show();
    this.notificationService.AddNotification(notificationDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.spinner.hide();
          this.notificationService.AddPortalNotification(resp);
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
  getDrugListByPrescriptionId(id) {
    const prescriptionDetails = { prescriptionId: id };
    this.pharmacistService
      .GetDrugListByPrescriptionId(prescriptionDetails)
      .subscribe({
        next: (res) => {
          if (!res.HasErrors) {
            res.PrescriptionDetails.forEach((element) => {
              var drug = {
                id: element.DrugId,
                name: element.DrugName,
                description: element.Description,
                refill: element.Refill,
                status: "Pending",
              };
              this.selectedDrugList.push(drug);
            });
            this.selectedPatient2(res.Patient);
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  CancelPrescription() {
    const dialogRef = this.dialog.open(this.CancelPrescriptionComponent, {
      maxWidth: "750px",
      disableClose: true,
    });
  }
  closeDialog() {
    this.dialog.closeAll();
  }
  Back() {
    this.dialog.closeAll();
    this.router.navigateByUrl("doctor/prescription/list");
  }

  AddUserActivity(prescriptionNo) {
    var userActivity = {
      ActivityType: ActivityType.CreatePrescription,
      ActivityName: "Created prescription.",
      UserName: this.currentUser.FirstName + " " + this.currentUser.LastName,
      Description:
        this.currentUser.FirstName +
        " " +
        this.currentUser.LastName +
        " Created prescription " +
        prescriptionNo,
      UserAccountId: this.currentUser.Id,
    };
    this.appService.AddUserActivity(userActivity).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
        }
      },
      error: () => {},
    });
  }
  GetFavoriteDrugs() {
    var doctorDetails = {
      doctorId: this.doctorDetails.doctor.Id,
    };

    this.filteredDrugs$ = this.prescriptionService
      .GetFavoriteDrugs(doctorDetails)
      .pipe(
        distinctUntilChanged(),
        map((data: any) => (data && data?.Rows) || [])
      );
  }
  onChange(event) {
    let drug = event.target.value;
    this.filteredDrugs$ = this.drugService.ListDrug(drug).pipe(
      map((data: any) => (data && data?.Rows) || []),
      tap(
        () => noop,
        (err) => {}
      )
    );
  }
  
  remove(sig: any): void {
    const index = this.sighs.indexOf(sig);

    if (index >= 0) {
      let description = this.createDrugForm.controls.description.value;
      if (description != null) {
        // var array = description.split(",");
        // const index2 = array.indexOf(sig.Description);
        // array.splice(index2, 1);
        // description = array.toString();
        if (this.sighs.length >= 1 && this.sighs[0].Id != sig.Id) {
          description = description.replace(", " + sig.Description, "");
        }
        if (this.sighs.length >= 1 && this.sighs[0].Id == sig.Id) {
          description = description.replace(sig.Description + ", ", "");
        }
        this.createDrugForm.controls.description.setValue(description);
        this.sighs.splice(index, 1);
        if (this.sighs.length == 0) {
          this.createDrugForm.controls.description.setValue("");
        }
      }
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    // this.fruits.push(event.option.viewValue);
    // this.fruitCtrl.setValue(null);
    this.sigCodeInput.nativeElement.value = "";
  }
  
}
